import { requireAdminPage } from '@/lib/admin-auth'
import { SubscriptionRequestsScreen } from './subscription-requests-screen'

export const dynamic = 'force-dynamic'

export default async function SubscriptionRequestsPage() {
  await requireAdminPage()

  return <SubscriptionRequestsScreen />
}
